var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import React from 'react';
import BaseHeading from '../BaseHeading/BaseHeading';
import './BaseHeader.scss';
var BaseHeader = function (props) {
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "BaseHeader" },
            React.createElement("div", { className: "BaseHeaderContent" },
                React.createElement(BaseHeading, __assign({}, props)),
                props.children),
            React.createElement("div", { className: "BaseHeaderEndSlot" }, typeof props.endSlot === 'function' ? React.createElement(props.endSlot, null) : props.endSlot))); } });
};
export default BaseHeader;
